import React, { Fragment, useState } from 'react';
import { SendMessage } from './SendMessage';
import { Header } from './Header';
import { MessagesList } from './MessagesList';
import { ConversationDropZone } from './ConversationDropzone';
import { useWarboxMessage } from 'src/hooks';

export const Thread = ({
    conversation,
    onOpenDetails,
    onOpenNotes,
    onOpenCallHistory,
    onLoadMoreMessages,
    hasMoreMessages,
    isLoadingMessages,
    isLoadingMoreMessages,
    onConversationStatusUpdated,
    onCloseChat,
}: {
    conversation: any;
    onOpenDetails?: () => void;
    onOpenNotes?: () => void;
    onOpenCallHistory?: () => void;
    onLoadMoreMessages?: () => void;
    hasMoreMessages?: boolean;
    isLoadingMessages?: boolean;
    isLoadingMoreMessages?: boolean;
    onConversationStatusUpdated?: (status: string) => void;
    onCloseChat?: () => void;
}) => {
    const {
        name,
        phone,
        normalizedPhone,
        contactCountryCode,
        image,
        tags,
        _id,
        linkedContactId,
        status,
        storeId,
        area,
        senderPhone,
        callerPhone,
        storeCountryCode,
        canSendMessages,
        isSilenced,
    } = conversation;

    const { messages } = useWarboxMessage();

    const [localFiles, setLocalFiles] = useState<File[]>([]);

    const handleFilesSelected = (files: File[]) => {
        setLocalFiles((current) => [...current, ...files]);
    };

    return (
        <Fragment>
            <Header
                name={name}
                phone={phone}
                normalizedPhone={normalizedPhone}
                contactCountryCode={contactCountryCode}
                image={image}
                tags={tags}
                linkedContactId={linkedContactId}
                conversationStatus={status}
                storeId={storeId}
                area={area}
                senderPhone={senderPhone}
                callerPhone={callerPhone}
                storeCountryCode={storeCountryCode}
                canSendMessages={canSendMessages}
                isSilenced={isSilenced}
                onOpenDetails={onOpenDetails}
                onOpenNotes={onOpenNotes}
                onOpenCallHistory={onOpenCallHistory}
                onConversationStatusUpdated={onConversationStatusUpdated}
                onCloseChat={onCloseChat}
                conversation={conversation}
            />
            <ConversationDropZone
                onDrop={(files) => handleFilesSelected(files)}
            >
                <MessagesList
                    messages={messages}
                    conversationId={_id}
                    onLoadMore={onLoadMoreMessages}
                    hasMore={hasMoreMessages}
                    isLoadingInitial={isLoadingMessages}
                    isLoadingMore={isLoadingMoreMessages}
                />
            </ConversationDropZone>

            <SendMessage
                conversation={conversation}
                handleFilesSelected={handleFilesSelected}
                localFiles={localFiles}
                setLocalFiles={setLocalFiles}
            />
        </Fragment>
    );
};
